/* Ricochet "What's Inside" tabs + scrollytelling (AJ Marketing redesign port, v2).
   Plain braces throughout. Re-initializes safely on Shopify editor section reloads.
   The desktop crossfade is scroll-driven: it shows the ingredient whose block is
   nearest a reading line placed inside the visible area, below the sticky header and
   tab bar, so the image matches the ingredient you are actually reading (no off-by-one,
   no early flip). On mobile the frame is hidden and each ingredient shows its own
   inline image, so this calculation is a harmless no-op there. */
(function () {
  'use strict';

  var rvIo = null;

  function measureOffset() {
    var off = 0;
    var rkNav = document.querySelector('.rk-inside.rk-headWrap');
    if (rkNav) {
      off = rkNav.offsetHeight;
    } else {
      var hdr = document.querySelector('header-component');
      if (hdr) {
        var cs = window.getComputedStyle(hdr);
        if (cs.position === 'sticky' || cs.position === 'fixed') {
          off = hdr.offsetHeight;
        }
      }
    }
    document.body.style.setProperty('--rk-offset', off + 'px');
    return off;
  }

  function tabs() { return Array.prototype.slice.call(document.querySelectorAll('.rk-inside .insideTabs .tab')); }
  function tracks() { return Array.prototype.slice.call(document.querySelectorAll('.rk-inside.rk-trackWrap')); }
  function activeTrack() { var t = null; tracks().forEach(function (x) { if (x.classList.contains('on')) { t = x; } }); return t; }

  /* The vertical line, inside the visible reading area (below the sticky header + tab
     bar), that decides which ingredient is currently being read. */
  function readingLine() {
    var off = measureOffset();
    var tb = document.querySelector('.rk-inside.rk-tabsWrap');
    var tbH = tb ? tb.offsetHeight : 0;
    var topOcc = off + tbH;
    return topOcc + (window.innerHeight - topOcc) * 0.45;
  }

  /* Show the frame for the ingredient whose block centre is nearest the reading line. */
  function updateCrossfade() {
    var track = activeTrack();
    if (!track) { return; }
    var steps = track.querySelectorAll('.scrollySteps .step');
    var frames = track.querySelectorAll('.scrollyFrame img');
    if (!steps.length || !frames.length) { return; }
    var target = readingLine();
    var best = 0, bd = Infinity;
    for (var i = 0; i < steps.length; i++) {
      var r = steps[i].getBoundingClientRect();
      var c = r.top + r.height / 2;
      var d = Math.abs(c - target);
      if (d < bd) { bd = d; best = i; }
    }
    for (var j = 0; j < frames.length; j++) {
      frames[j].classList.toggle('show', j === best);
    }
  }

  function tabsHome() {
    var bar = document.querySelector('.rk-inside.rk-tabsWrap');
    if (!bar) { return 0; }
    var section = bar.closest('.shopify-section') || bar;
    return section.getBoundingClientRect().top + window.pageYOffset - measureOffset();
  }

  function showTrack(id, scroll, push) {
    var target = null;
    tracks().forEach(function (t) { if (t.getAttribute('data-track') === id) { target = t; } });
    if (!target) { return false; }
    tracks().forEach(function (t) { t.classList.toggle('on', t === target); });
    var bar = document.querySelector('.rk-inside .insideTabs');
    tabs().forEach(function (b) {
      var on = b.getAttribute('data-track') === id;
      b.classList.toggle('on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && bar) {
        bar.scrollTo({ left: b.offsetLeft - (bar.clientWidth - b.offsetWidth) / 2, behavior: 'smooth' });
      }
    });
    if (scroll) { window.scrollTo(0, tabsHome()); }
    updateCrossfade();
    if (push && window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + id);
    }
    return true;
  }

  function init() {
    if (!document.querySelector('.rk-inside .insideTabs')) { return; }
    measureOffset();

    if (rvIo) { rvIo.disconnect(); }
    rvIo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); rvIo.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.rk-inside .rv').forEach(function (el) {
      el.style.transitionDelay = (el.getAttribute('data-d') || 0) + 'ms';
      rvIo.observe(el);
    });

    tabs().forEach(function (b) {
      b.onclick = function () { showTrack(b.getAttribute('data-track'), true, true); };
    });

    var initial = window.location.hash.replace('#', '');
    if (!showTrack(initial, initial !== '', false)) {
      var first = tabs().length ? tabs()[0].getAttribute('data-track') : null;
      if (first) { showTrack(first, false, false); }
    }
    updateCrossfade();
  }

  window.addEventListener('scroll', updateCrossfade, { passive: true });
  window.addEventListener('hashchange', function () {
    showTrack(window.location.hash.replace('#', ''), true, false);
  });
  window.addEventListener('resize', function () { measureOffset(); updateCrossfade(); });
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
